import styled from 'styled-components';

import { colors } from 'theme/theme';

export const Container = styled.div`
  display: flex;
  gap: 27px;
`;

export const StarContainer = styled.div<{
  $disabled?: boolean;
  $filled: boolean;
}>`
  cursor: ${(props) => (props.$disabled ? 'not-allowed' : 'pointer')};
  position: relative;

  .star-filled,
  .star-outline {
    position: absolute;
  }

  .star-outline {
    color: ${(props) =>
      props.$filled ? 'transparent' : colors.lightContentGrey};
  }

  .star-filled {
    color: ${(props) => (props.$filled ? colors.brandBlue : 'transparent')};
  }

  &:hover {
    .star-outline {
      color: ${(props) => (props.$filled ? 'transparent' : colors.brandBlue)};
    }
  }
`;

export const IconContainer = styled.div`
  height: 27px;
  width: 27px;
  transition: transform 0.25s linear;

  &:hover {
    transform: scale(1.3);
  }
`;
